import { gql } from '@apollo/client'

export const SelectedQuery = gql`
  query SelectedAssetTypeSelector($companyId: ID!, $id: ID) {
    assetTypes(companyId: $companyId, filters: { idEq: $id }) {
      nodes {
        id
        name
        image { 
          id
          url
        }
      }
    }
  }
`

export const Query = gql`
  query AssetTypeSelector(
    $companyId: ID!,
    $filters: AssetTypeFilters,
    $after: String,
    $before: String,
    $first: Int,
    $last: Int
  ) {
    assetTypes(companyId: $companyId, filters: $filters, after: $after, before: $before, first: $first, last: $last) {
      nodes {
        id
        name
        image { 
          id
          url
        }
      }
      pageInfo { startCursor endCursor hasNextPage hasPreviousPage }
    }
  }
`
